/* Sauer's Bakehouse — continuous marquee loop for opt-in carousels.
 * Turns a `.splide__list` inside a `.sr-cloop` wrapper into a seamless,
 * always-sliding strip (paused on hover). Used where the merchant wants a
 * gentle continuous loop instead of a paged slider. Splide must be disabled
 * for that section (enable_desktop_slider / swiper_on_mobile = false) so the
 * two don't fight over the track transform. */
(function () {
  function setup(wrap) {
    if (!wrap || wrap.dataset.cloopReady) return;
    var list = wrap.querySelector('.sr-cloop-list') || wrap.querySelector('[data-cloop-list]') || wrap.querySelector('.splide__list');
    if (!list) return;
    var items = [].slice.call(list.children);
    if (items.length < 2) return; // nothing to loop
    wrap.dataset.cloopReady = '1';

    // Force a single flowing row inline — beats the theme's grid classes
    // regardless of stylesheet order/specificity (this is what kept the
    // "Ultimate Baking Kits" strip from wrapping to two rows).
    list.style.setProperty('display', 'flex', 'important');
    list.style.setProperty('flex-wrap', 'nowrap', 'important');
    list.style.setProperty('width', 'max-content', 'important');

    var track = wrap.querySelector('.splide__track');
    if (track) {
      track.classList.add('sr-cloop__track');
      // Clip the strip to the track so the edge-fade mask (sauers-design.css)
      // has something to fade against — the strip is restricted to the content
      // area and fades in/out at both sides (client request — Update 2, page 5).
      track.style.setProperty('overflow', 'hidden', 'important');
    }

    // Repeat the set enough times that EACH half of the strip is at least as wide
    // as the viewport, then translateX(-50%) wraps with no empty gap at the end
    // (the cause of the "runs out of cards then jolts back to the start" jump).
    // With few/narrow cards a single duplicate isn't enough to keep the viewport
    // full through the whole cycle. Keep the total even so -50% lands on a set
    // boundary and the loop stays seamless.
    var wrapW = wrap.getBoundingClientRect().width || wrap.offsetWidth || 0;
    var setW = list.scrollWidth || 0; // width of one original set (incl. margins)
    var halfSets = 1;
    if (setW > 0 && wrapW > 0) {
      halfSets = Math.min(6, Math.max(1, Math.ceil((wrapW + 1) / setW)));
    }
    var extraSets = halfSets * 2 - 1; // we already have 1 set rendered
    for (var s = 0; s < extraSets; s++) {
      items.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        list.appendChild(clone);
      });
    }

    var dur = parseFloat(wrap.dataset.cloopSpeed);
    if (!dur || dur < 5) dur = 40;
    wrap.style.setProperty('--sr-cloop-dur', dur + 's');

    // Keep any autoplaying videos inside the strip playing, and stop the mobile
    // long-press "download/save video" menu — press-and-hold is reserved for
    // pausing the marquee (below). Mirrors the sr-social reel strip.
    [].slice.call(list.querySelectorAll('video')).forEach(function (v) {
      v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    // Belt-and-suspenders for Android's long-press context menu over the strip.
    wrap.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    // Press-and-hold to pause the marquee on touch; release to resume
    // (client request — Update 2, page 2). Desktop already pauses on hover
    // via the CSS `:has(> *:hover)` rule.
    var srPause = function () { list.style.animationPlayState = 'paused'; };
    var srResume = function () { list.style.animationPlayState = ''; };
    wrap.addEventListener('touchstart', srPause, { passive: true });
    wrap.addEventListener('touchend', srResume, { passive: true });
    wrap.addEventListener('touchcancel', srResume, { passive: true });
  }

  function init(scope) {
    [].slice.call((scope || document).querySelectorAll('.sr-cloop')).forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Sections can render after load (theme editor, AJAX); pick them up too.
  var mo = new MutationObserver(function (muts) {
    var sawAdds = false;
    muts.forEach(function (m) {
      [].slice.call(m.addedNodes || []).forEach(function (n) {
        if (n.nodeType !== 1) return;
        sawAdds = true;
        if (n.matches && n.matches('.sr-cloop')) setup(n);
        if (n.querySelectorAll) init(n);
      });
    });
    // Cards can be added INTO an already-present but still-empty .sr-cloop
    // (e.g. the cart upsell's async recommendations). Retry those — setup()
    // is a no-op once a wrapper is ready, so this can't double-clone.
    if (sawAdds) {
      [].slice.call(document.querySelectorAll('.sr-cloop:not([data-cloop-ready])')).forEach(setup);
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
